module.exports = __webpack_public_path__ + "assets/img/banner2.15667970.png";